<div class="modal fade" id="incompleteDataModal" tabindex="-1" aria-labelledby="incompleteDataModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content custom-modal">
      <!-- Modal Header -->
      <div class="modal-header custom-header">
        <h5 class="modal-title" id="incompleteDataModalLabel">
          Incomplete Data - {{ modalData.title }}
        </h5>
        <button type="button" class="btn-close-custom" (click)="closeModal()" aria-label="Close">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body custom-body">

        <!-- Detail View - Data dari API Backend -->
        <div *ngIf="modalData.isDetailView">
          <div *ngFor="let monthGroup of getGroupedDataByMonth()" class="month-group">
            <!-- Month Header -->
            <div class="month-header">
              <span class="month-name">{{ monthGroup.month }}</span>
              <div class="green-indicator"></div>
            </div>

            <!-- Dates List untuk bulan ini -->
            <div class="dates-container">
              <div *ngFor="let dateItem of monthGroup.dates" class="date-item">
                <div class="date-label">{{ dateItem.formattedDate }}</div>
                <!-- Bisa ditambahkan info property jika diperlukan -->
                <div class="property-info" *ngIf="dateItem.property_name_list" style="font-size: 0.8em; color: #666; margin-top: 2px;">
                  Properties: {{ dateItem.property_name_list }}
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State untuk Detail View -->
          <div *ngIf="modalData.detailData.length === 0" class="empty-state">
            <p class="text-muted">No incomplete dates found</p>
          </div>
        </div>

        <!-- Fallback View - Data dari incomplete_data string (tampilan lama) -->
        <div *ngIf="!modalData.isDetailView">
          <!-- Month Header -->
          <div class="month-header">
            <span class="month-name">{{ getCurrentMonth() }}</span>
            <div class="green-indicator"></div>
          </div>

          <!-- Dates List -->
          <div class="dates-container">
            <div *ngFor="let date of modalData.dates" class="date-item">
              {{ date }}
            </div>
          </div>

          <!-- Empty State untuk Fallback View -->
          <div *ngIf="modalData.dates.length === 0" class="empty-state">
            <p class="text-muted">No incomplete dates found</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
